export default {
  "mfaInput": "_mfaInput_1ybjl_1",
  "mfaInputSection": "_mfaInputSection_1ybjl_12",
  "mfaInputSlot": "_mfaInputSlot_1ybjl_18",
  "mfaInputSlotActive": "_mfaInputSlotActive_1ybjl_36",
  "mfaFakeDash": "_mfaFakeDash_1ybjl_42"
};import "ni:sha-256;L-n_xpjWPm7_Lu9C0wW16SYTazJtiPCSXDsHiGpTcmI";